/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import './LanguageQuickList.css';

import EarthWorld from 'components/images/EarthWorld';
import { colorClassNames } from 'styles/styleUtility';
import { LanguageWithCountryCodeOption, LanguageWithCountryCode } from 'components/localization';

class LanguageQuickList extends React.Component {

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadInitialData();
  }

  onChange(e) {
    const id = parseInt(e.target.value, 10);
    const localeData = this.props.localeList.filter(l => l.id === id)[0];
    this.props.onChange(localeData);
  }

  render() {
    const optionList = this.props.localeList.map((v) => <LanguageWithCountryCodeOption key={v.id} locale={v} isDisabled={false} />);

    return (
      <div className="cmp-languagequicklist">
        <div className="cmp-languagequicklist-content">
          <div className={`language-code ${colorClassNames.font(this.props.color)}`}>
            <LanguageWithCountryCode locale={this.props.selectedLocale} />
          </div>
          <select
            name={this.props.htmlId}
            id={this.props.htmlId}
            value={this.props.value}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            onChange={this.onChange}
          >
            {optionList}
          </select>
        </div>

        <label htmlFor={this.props.htmlId}>
          <EarthWorld size={this.props.size} color={this.props.color} />
        </label>
      </div>
    );
  }
}
LanguageQuickList.propTypes = {
  htmlId: PropTypes.string.isRequired,
  loadInitialData: PropTypes.func,
  localeList: PropTypes.array,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  color: colorClassNames.nameProp,
  size: PropTypes.string,
};
LanguageQuickList.defaultProps = {
  color: 'middle-gray',
  size: '24px',
};

export default LanguageQuickList;
